
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClickFlags extends Vue {
  @Prop() modal?: boolean;
  @Prop() complete?: boolean;
  @Prop() arrowLeft?: boolean;
  @Prop() incorrect?: boolean;
}
